import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Utils } from 'core/utils';
import { ButtonsAssignment } from './dialog-buttons.component';

@Component({
    template: '',
    styleUrls: ['./dialog.scss'],
    standalone: false
})
export class DialogComponent
{
  public buttons: ButtonsAssignment;
  public warningUrl: string = Utils.url('./assets/img/msg-warning.svg');

  constructor(@Inject(MAT_DIALOG_DATA) protected dialogData: any)
  {
    this.buttons = this.dialogData.buttons ? this.dialogData.buttons : {};
  }
}
